module.exports = __webpack_public_path__ + "img/registration_back_outline.ac861a70.svg";